import '../scss/main.scss';
const window = global.window;
import './plugins.js';
import './_main.js';
